import React, {FC} from 'react';
import styled from 'styled-components';

import {Skeleton, SkeletonColorSchemesEnum} from '../../../components/common/skeleton';

/*
 * Props.
 */

interface DevelopersHiddenInputSkeletonProps {
  hasRevealButton?: boolean;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  margin-top: 20px;
`;

const StyledTitleSkeleton = styled(Skeleton)`
  margin-bottom: 7px;
`;

const StyledInputWrapperDiv = styled.div`
  display: flex;
  flex-flow: row;
  gap: 8px;
`;

/*
 * Component.
 */

export const DevelopersHiddenInputSkeleton: FC<DevelopersHiddenInputSkeletonProps> = ({hasRevealButton}) => (
  <StyledWrapperDiv>
    <StyledTitleSkeleton height="16px" width="100px" />
    <StyledInputWrapperDiv>
      <Skeleton width="395px" height="30px" scheme={SkeletonColorSchemesEnum.GREY10} />
      <Skeleton width="88px" height="30px" borderRadius="9000px" scheme={SkeletonColorSchemesEnum.GREY10} />
      {hasRevealButton && (
        <Skeleton width="96px" height="30px" borderRadius="9000px" scheme={SkeletonColorSchemesEnum.GREY10} />
      )}
    </StyledInputWrapperDiv>
  </StyledWrapperDiv>
);
